import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { IconCross } from 'sections/Benefits/svg';
import { faq } from 'sections/Benefits/data';
import styles from 'styles/pages/Benefits/Benefits.module.scss';

const cn = classNames.bind(styles);

const SectionFaq = (): ReactElement => {
  const faqList = faq.map((item) => {
    return (
      <div className={cn('faq__item')} key={item.id}>
        <input type="checkbox" name={item.id} id={item.id} />
        <label htmlFor={item.id} className={cn('faq__item-label')}>
          <p>{item.question}</p>
          <div>{IconCross}</div>
        </label>
        <div className={cn('faq__item-content')}>
          <p className={cn('faq__item-content-text')}>{item.answer}</p>
        </div>
      </div>
    );
  });

  return (
    <section className={cn('faq')}>
      <div className={cn('container')}>
        <h2 className={cn('faq__title')}>Frequently Asked Questions</h2>
        <ul className={cn('faq__list')}>
          {faqList}
        </ul>
      </div>
    </section>
  );
};

export default SectionFaq;